export const faqs = [
  {
    id: 1,
    question: '皇冠App是否完全免费？',
    answer: '皇冠App基础功能完全免费，用户可免费下载、注册和使用核心功能。部分高级功能可能需要付费订阅，具体收费标准请查看应用内说明。我们承诺所有收费项目均提前明确告知，不存在隐性收费。',
  },
  {
    id: 2,
    question: '皇冠App支持哪些操作系统？',
    answer: '皇冠App目前支持iOS 14.0及以上版本和Android 8.0及以上版本。我们正在进行HarmonyOS版本的适配开发，预计将在下一阶段推出，敬请期待。',
  },
  {
    id: 3,
    question: '如何确保下载的是正版皇冠App？',
    answer: '请务必通过以下官方渠道下载：iOS用户通过App Store搜索"皇冠App"下载；Android用户通过本官方网站下载APK安装包。切勿从第三方应用商店或不明链接下载，以免下载到假冒版本。您还可以通过应用内的"正版验证"功能确认应用真伪。',
  },
  {
    id: 4,
    question: '皇冠App会收集哪些个人信息？',
    answer: '皇冠App严格遵循"最小必要"原则，仅收集提供服务所必需的信息，包括：账户注册所需的手机号或邮箱、设备基础信息用于安全防护、使用数据用于产品优化。所有数据收集均获得用户明确授权，详细内容请参阅《隐私政策》。',
  },
  {
    id: 5,
    question: '忘记密码如何找回？',
    answer: '在登录页面点击"忘记密码"，输入注册时使用的手机号或邮箱，系统将发送验证码。验证身份后即可设置新密码。如遇到任何问题，可联系官方客服获取人工协助。',
  },
  {
    id: 6,
    question: '皇冠App更新频率如何？',
    answer: '我们采用敏捷开发模式，通常每2-4周发布一个版本更新。重要安全补丁会在24小时内紧急推送。用户可以在应用内开启"自动更新"功能，确保始终使用最新版本。',
  },
  {
    id: 7,
    question: '使用皇冠App需要网络连接吗？',
    answer: '皇冠App的大部分核心功能需要网络连接才能正常使用。部分已缓存的内容支持离线查看。建议在Wi-Fi或稳定的移动网络环境下使用，以获得最佳体验。',
  },
  {
    id: 8,
    question: '如何联系皇冠App客服？',
    answer: '您可以通过以下方式联系我们：1）应用内"帮助与反馈"功能提交工单；2）发送邮件至官方客服邮箱；3）拨打官方客服热线（工作日9:00-18:00）。我们承诺在工作时间内2小时内响应您的需求。',
  },
];